import { WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';

import { ICurriculum } from '../actions/imstat';
import { CurriculumTypes } from '../components/CurriculumCard';
import CardPagination from './CardPagenation';
import CurriculumCard from './CurriculumCard';

const styles = (theme: Theme) =>
	createStyles({
		pagination: {
			marginTop: theme.spacing(2),
		},
	});

interface IProps extends React.Props<{}>, WithStyles<typeof styles>, IMyProps {}

interface IState {
	startRowIndex: number;
	endRowIndex: number;
}

/**
 * カリキュラムカード形式
 */
class ImstatCurriculumCard extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			endRowIndex: 4,
			startRowIndex: 0,
		};
	}

	public render() {
		const displayData = this.getDisplayData();

		return (
			<>
				<Grid
					container={true}
					spacing={1}
					direction="row"
					justify="center"
					alignItems="stretch"
				>
					{displayData.map((datum, i) => (
						<Grid key={i} item={true}>
							<CurriculumCard
								data={datum}
								type={this.props.type}
							/>
						</Grid>
					))}
				</Grid>
				<CardPagination
					onPageChange={this.handleChangePage}
					dataSize={this.props.data.length}
					className={this.props.classes.pagination}
				/>
			</>
		);
	}

	/**
	 * ページ変更時処理
	 */
	protected handleChangePage = (
		startRowIndex: number,
		endRowIndex: number
	) => {
		this.setState({ endRowIndex, startRowIndex });
	};

	/**
	 * 表示データ取得処理
	 */
	protected getDisplayData() {
		const { endRowIndex, startRowIndex } = this.state;
		const displayData = this.props.data.slice(
			startRowIndex,
			endRowIndex + 1
		);
		return displayData;
	}
}

interface IMyProps {
	data: ICurriculum[];
	type: CurriculumTypes;
}

export default withStyles(styles)(ImstatCurriculumCard);



// WEBPACK FOOTER //
// ./src/components/ImstatCurriculumCard.tsx